import React from 'react';
import PropTypes from 'prop-types';
import PageSection from '../PageSection';
import { Grid, Typography } from '@mui/material';
import Image from 'next/image';
import ActionButton from '../ActionButton';
import ImageZoom from '../ImageZoom';

const ActionImageSection = ({ actionText, actionLink, image, imageAlt }) => {
  return (
    <PageSection maxWidth={'md'} spacing={'slim'}>
      <Grid container justifyContent={'center'} alignItems={'center'} direction={'column'}>
        <Grid item>
          <Typography align={'center'} variant={'h4'}>
            {/*Lorem ipsum dolor*/}
          </Typography>
        </Grid>
        <Grid item>
          <ImageZoom>
            <Image unoptimized={true} src={image} alt={imageAlt} width={604} height={315} />
          </ImageZoom>
        </Grid>
        <Grid item>
          <ActionButton link={actionLink} text={actionText} />
        </Grid>
      </Grid>
    </PageSection>
  );
};

ActionImageSection.propTypes = {
  actionText: PropTypes.string.isRequired,
  actionLink: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};

ActionImageSection.defaultProps = {};

export default ActionImageSection;
